import React from 'react'
import { withAsync } from '@/components/Async'
import Blank from '@/layouts/Blank'
import type { RouteConfig } from 'react-router-config'
import { OwCommodity } from '@yy/one-icon'
import { withRedirect } from '@/components/Authorization'

const routes: RouteConfig[] = [
  {
    name: 'goods',
    menuTitle: 'common.sku',
    path: '/goods',
    component: withRedirect(Blank),
    icon: <OwCommodity />,
    authCode: 'skus',
    routes: [
      {
        menuTitle: 'goods.list.title',
        component: withAsync(() => import(/* webpackChunkName: "goods" */ '@/containers/Goods/Index')),
        path: '/list',
        authCode: 'skus:management',
        exact: true,
      },
      {
        menuTitle: 'groupGoods.list.title',
        component: withAsync(() => import(/* webpackChunkName: "GroupGoods" */ '@/containers/Goods/GroupGoods')),
        path: '/groupGoods',
        authCode: 'skus:group',
        exact: true,
      },
      {
        component: withAsync(() => import(/* webpackChunkName: "ModifyGoods" */ '@/containers/Goods/ModifyGoods')),
        path: '/add',
        exact: true,
        // 用于关联parentKeys，没有menuTitle会被过滤
        menuTitle: '添加商品',
        hideInMenu: true,
        parentKeys: ['/goods/list'],
      },
      {
        component: withAsync(() => import(/* webpackChunkName: "ModifyGoods" */ '@/containers/Goods/ModifyGoods')),
        path: '/modify/:skuId',
        exact: true,
        // 用于关联parentKeys，没有menuTitle会被过滤
        menuTitle: '编辑商品',
        hideInMenu: true,
        parentKeys: ['/goods/list'],
      },
      {
        component: withAsync(() => import(/* webpackChunkName: "ModifyGroupGoods" */ '@/containers/Goods/ModifyGroupGoods')),
        path: '/addGroupGoods',
        exact: true,
        // 用于关联parentKeys，没有menuTitle会被过滤
        menuTitle: '添加组合商品',
        hideInMenu: true,
        parentKeys: ['/goods/groupGoods'],
      },
      {
        component: withAsync(() => import(/* webpackChunkName: "ModifyGroupGoods" */ '@/containers/Goods/ModifyGroupGoods')),
        path: '/ModifyGroupGoods/:skuGroupId',
        exact: true,
        // 用于关联parentKeys，没有menuTitle会被过滤
        menuTitle: '编辑组合商品',
        hideInMenu: true,
        parentKeys: ['/goods/groupGoods'],
      },
    ],
  },
]

export default routes
